import { configurePusher } from 'pusher-redux';
import * as PusherRedux from 'pusher-redux';
import * as actions from './actions';

// FIX: Use standard named import for uuid v8+.
import { v1 as uuidV1 } from 'uuid';

const config: any = {
  store: null,
};

export default function configureSocket(store: any) {
  config.store = store;
  
  // We return the configured pusher instance
  return configurePusher(store, process.env.REACT_APP_PUSHER_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    encrypted: true,
  });
}

export function subscribe(channelName: string, eventName: string, actionType: string) {
  if (!config.store) return; // Safety Check

  const id = uuidV1();
  config.store.dispatch(actions.subscribe(id, channelName, eventName, actionType));
  PusherRedux.subscribe(channelName, eventName, actionType);
}

export function unsubscribe(id: string) {
  if (!config.store) return; // Safety Check

  const state = config.store.getState();
  if (state && typeof state.getIn === 'function') {
    const subscription = state.getIn(['socket', 'subscriptions', id]);
    if (subscription) {
      const { channelName, eventName, actionType } = subscription;
      config.store.dispatch(actions.unsubscribe(id));
      PusherRedux.unsubscribe(channelName, eventName, actionType);
    }
  }
}

export function refreshSubscriptions() {
  if (!config.store) return; // Safety Check

  const state = config.store.getState();
  if (state && typeof state.getIn === 'function') {
    const subscriptions = state.getIn(['socket', 'subscriptions']);
    if (subscriptions) {
      unsubscribeAll();
      subscriptions.forEach((s: any) => subscribe(s.channelName, s.eventName, s.actionType));
    }
  }
}

export function unsubscribeAll() {
  if (!config.store) return; // Safety Check

  const state = config.store.getState();
  if (state && typeof state.getIn === 'function') {
    const subscriptions = state.getIn(['socket', 'subscriptions']);
    if (subscriptions) {
      subscriptions.forEach((s: any) => unsubscribe(s.id));
    }
  }
}

export function getAccountChannel(accountId: any) {
  return `account-${accountId}`;
}